import { Injectable, computed, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { GatewayConfigStore } from './gateway-config.store';
import { GatewayConfigApi } from './gateway-config.api';

@Injectable({ providedIn: 'root' })
export class GatewayConfigFacade {
  readonly #store = inject(GatewayConfigStore);
  readonly #api = inject(GatewayConfigApi);

  readonly config = this.#store.config;
  readonly loading = this.#store.loading;
  readonly error = this.#store.error;

  readonly publicClientKey = computed(() => this.#store.config()?.publicClientKey ?? null);
  readonly threeDsEnabled = computed(() => this.#store.config()?.threeDsEnabled ?? false);

  #loadPromise?: Promise<void>;

  /** Fetches the gateway config once; concurrent/repeat calls share the same in-flight request. */
  load(): Promise<void> {
    if (this.#store.config()) return Promise.resolve();
    if (this.#loadPromise) return this.#loadPromise;

    this.#store.setLoading(true);
    this.#loadPromise = firstValueFrom(this.#api.get()).then(result => {
      if (result.ok) {
        this.#store.setConfig(result.data);
      } else {
        this.#store.setError(result.error);
        this.#loadPromise = undefined;
      }
    });

    return this.#loadPromise;
  }
}
